import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsIntegration = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize dataLayer for GTM
    window.dataLayer = window.dataLayer || [];
    
    // Track page view on route change
    window.dataLayer.push({
      'event': 'page_view',
      'page_path': location.pathname,
      'page_title': document.title
    });

    // Meta Pixel PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }

    // GA4 PageView (handled automatically by GTM typically)
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title
      });
    }
  }, [location]);

  return null;
};

// Event tracking helper functions
export const trackEvent = (eventName, eventData = {}) => {
  // GTM Event
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': eventName,
      ...eventData
    });
  }

  // Meta Pixel Event
  if (window.fbq) {
    window.fbq('track', eventName, eventData);
  }

  // GA4 Event
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }

  console.log('Event tracked:', eventName, eventData);
};

// Specific event trackers
export const trackCTAClick = (ctaName, ctaLocation) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    cta_location: ctaLocation
  });
};

export const trackOrderInitiated = (quantity, total) => {
  trackEvent('order_initiated', {
    quantity: quantity,
    value: total,
    currency: 'INR'
  });
};

export const trackPurchase = (orderId, value) => {
  trackEvent('purchase', {
    transaction_id: orderId,
    value: value,
    currency: 'INR'
  });

  // Meta Pixel Purchase Event
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      value: value,
      currency: 'INR'
    });
  }
};

export const trackLeadSubmission = (leadSource) => {
  trackEvent('lead_submission', {
    lead_source: leadSource
  });

  // Meta Pixel Lead Event
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: leadSource
    });
  }
};

export default AnalyticsIntegration;
